/**
 * Hooks for the Course catalog domain.
 *
 * Replaces Wized requests: get_course_list, get_course_item, get_category_relation
 * Replaces Wized elements: card_item, card_title, card_des, card_time, card_tag,
 *   popular, free, is_free, already-bought-button, add-to-cart-button,
 *   add-to-dash, login-to-buy-button, course_skeleton, card_item_saved, etc.
 */

import { useAsync } from "./useAsync";
import * as api from "../lib/api";

/** Fetch the full course catalog. */
export function useCourseList() {
  return useAsync(() => api.getCourseList(), []);
}

/** Fetch a single course by ID. */
export function useCourseItem(courseId: string | null) {
  return useAsync(
    () => api.getCourseItem(courseId!),
    courseId ? [courseId] : null,
  );
}

/** Fetch course categories for filtering. */
export function useCourseCategories() {
  return useAsync(() => api.getCourseCategories(), []);
}
